import React, { useState } from 'react';
import { API_URL } from '../config';
import { useAuth } from '../contexts/AuthContext';

const inputStyle = {
  width: '100%',
  height: 44,
  border: 'none',
  borderBottom: '1px solid var(--rule)',
  background: 'transparent',
  color: 'var(--ink)',
  fontSize: 17,
  fontFamily: 'var(--font-sans)',
  outline: 'none',
  padding: '4px 0',
  letterSpacing: '-0.005em',
};

const labelStyle = {
  fontFamily: 'var(--font-mono)',
  fontSize: 11,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: 'var(--ink-3)',
  display: 'block',
  marginBottom: 6,
};

/**
 * PasswordLoginForm - Email + password sign-in.
 * Inkwell editorial styling: underline-style inputs, mono labels, dark CTA.
 */
function PasswordLoginForm({ onSwitchToMagicLink }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');
      login(data.token, data.teacher);
      window.history.replaceState({}, '', '/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: 24 }}>
        <label style={labelStyle}>Email</label>
        <input
          type="email"
          style={inputStyle}
          placeholder="you@school.edu"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={(e) => (e.target.style.borderBottomColor = 'var(--ink)')}
          onBlur={(e) => (e.target.style.borderBottomColor = 'var(--rule)')}
          required
        />
      </div>
      <div style={{ marginBottom: 32 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <label style={labelStyle}>Password</label>
          <button
            type="button"
            onClick={() => onSwitchToMagicLink && onSwitchToMagicLink()}
            style={{
              color: 'var(--ink-2)',
              textDecoration: 'underline',
              textUnderlineOffset: 3,
              fontSize: 11,
              background: 'transparent',
              border: 0,
              padding: 0,
              cursor: 'pointer',
              fontFamily: 'var(--font-sans)',
            }}
          >
            Forgot?
          </button>
        </div>
        <input
          type="password"
          style={inputStyle}
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          minLength={8}
          required
          onFocus={(e) => (e.target.style.borderBottomColor = 'var(--ink)')}
          onBlur={(e) => (e.target.style.borderBottomColor = 'var(--rule)')}
        />
      </div>
      {error && <p style={{ color: 'var(--error)', fontSize: 13, marginBottom: 16 }}>{error}</p>}
      <button
        type="submit"
        disabled={loading}
        style={{
          width: '100%',
          height: 52,
          background: 'var(--ink)',
          color: 'var(--paper)',
          border: 'none',
          fontSize: 15,
          fontWeight: 500,
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.5 : 1,
          fontFamily: 'var(--font-sans)',
        }}
      >
        {loading ? 'Signing in…' : 'Sign in'}
      </button>
    </form>
  );
}

export default PasswordLoginForm;
